import React from 'react';

const PagedNotFoundIcon = () => (
  <svg
    viewBox="0 0 243 232"
    xmlns="http://www.w3.org/2000/svg"
    fillRule="evenodd"
    clipRule="evenodd"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeMiterlimit="1.5"
  >
    <path fill="none" d="M0 0h242.463v231.333H0z" />
    <clipPath id="a">
      <path d="M0 0h242.463v231.333H0z" />
    </clipPath>
    <g>
      <path fill="#f2f2f2" d="M1.923 183.636h239.333v29.667H1.923z" />
      <path fill="#59e9c9" d="M76.624 2.646h95v185.421h-95z" />
      <path
        d="M171.624 188.068h-95V2.646h95v185.422zM82.625 8.646v173.422h82.999V8.646H82.625z"
        fill="#a3a6d0"
      />
      <path
        d="M26.206 39.672c.368-11.135 9.51-20.049 20.734-20.049 11.225 0 20.367 8.914 20.735 20.049h.011v37.684H26.195V39.672h.011z"
        fill="#f78fa6"
      />
      <path
        d="M29.84 46.276c.304-9.183 7.844-16.534 17.1-16.534 9.257 0 16.797 7.351 17.101 16.534h.009v31.08H29.831v-31.08h.009z"
        fill="#e57790"
      />
      <path fill="#867eaf" d="M44.27 133.95h14.989v57.9H44.27z" />
      <path
        d="M58.614 192.831a.981.981 0 0 0-.98-.981H45.25c-.541 0-.98.44-.98.981v1.961c0 .541.439.981.98.981h12.384c.541 0 .98-.44.98-.981v-1.961z"
        fill="#fabc4b"
      />
      <path
        d="M53.416 195.773a6.006 6.006 0 0 1 5.198-9.005 6.006 6.006 0 0 1 5.199 9.005H53.416z"
        fill="#fabc4b"
      />
      <path fill="#9e97c0" d="M31.564 137.872h14.989v57.9H31.564z" />
      <g fill="#fabc4b">
        <path d="M45.908 196.753a.98.98 0 0 0-.981-.98H32.544a.98.98 0 0 0-.98.98v1.961c0 .541.439.981.98.981h12.383c.542 0 .981-.44.981-.981v-1.961z" />
        <path d="M40.709 199.695a6.006 6.006 0 0 1 5.199-9.005 6.006 6.006 0 0 1 5.199 9.005H40.709z" />
      </g>
      <path
        d="M62.251 82.728c-.307-6.235-7.579-11.222-16.505-11.222-8.927 0-16.199 4.987-16.506 11.222h-.01v56.091h33.031V82.728h-.01z"
        fill="#fccd6c"
      />
      <path
        d="M69.026 82.781a7.155 7.155 0 0 0-7.152-7.152 7.155 7.155 0 0 0-7.152 7.152v14.857a7.156 7.156 0 0 0 7.152 7.152 7.156 7.156 0 0 0 7.152-7.152V82.781z"
        fill="#fccd6c"
      />
      <path d="M62.354 75.701z" fill="#767191" />
      <path
        d="M50.534 69.753a1.29 1.29 0 0 0-1.29-1.29h-4.607c-.712 0-1.291.578-1.291 1.29v5.703c.01 2.264 7.197 2.065 7.188 0v-5.703z"
        fill="#fbe3e9"
      />
      <path
        d="M64.05 43.313c0-9.443-7.666-17.11-17.11-17.11-9.443 0-17.109 7.667-17.109 17.11v11.18c0 9.443 7.666 17.11 17.109 17.11 9.444 0 17.11-7.667 17.11-17.11v-11.18z"
        fill="#fcecf0"
      />
      <path
        d="M64.059 44.816a3.608 3.608 0 0 1 3.607 3.607 3.609 3.609 0 0 1-3.607 3.607c-1.99 0-1.99-7.214 0-7.214zM29.206 51.852a3.609 3.609 0 0 1-3.607-3.607 3.609 3.609 0 0 1 3.607-3.607c1.991 0 1.991 7.214 0 7.214z"
        fill="#fcecf0"
      />
      <path
        d="M45.654 63.487c.239 1.832 2.222 3.226 4.588 3.226 2.367 0 4.349-1.394 4.588-3.226h-9.176z"
        fill="#767191"
      />
      <path
        d="M54.83 63.425h-9.176c.001.31.072.636.228.981h8.709c.148-.248.226-.578.239-.981z"
        fill="#fff"
      />
      <path
        d="M47.885 66.23c.351-.561 1.274-.952 2.357-.952 1.083 0 2.006.391 2.357.952-.678.304-1.474.478-2.357.483a5.988 5.988 0 0 1-2.357-.483z"
        fill="#f8cfd8"
      />
      <path d="M50.206 63.372a1.208 1.208 0 1 0-2.36 0h2.36z" fill="#f78ea5" />
      <path
        d="M52.62 63.372a1.208 1.208 0 1 0-2.36 0h2.36zM49.046 66.552a1.208 1.208 0 1 0 2.387.254c0-.086.018-.171 0-.254-.784.134-1.597.16-2.387 0z"
        fill="#f78ea5"
      />
      <path d="M49.464 56.891a1.36 1.36 0 1 0 2.657 0h-2.657z" fill="#fedee5" />
      <circle cx="40.96" cy="56.043" r="2.26" fill="#f9a8ba" />
      <circle cx="61.577" cy="56.043" r="2.26" fill="#f9a8ba" />
      <path d="M56.596 49.67h2.59" fill="none" stroke="#fff" strokeWidth="2" />
      <circle cx="57.891" cy="50.309" r="1.295" fill="#6a6488" />
      <path d="M43.028 49.67h2.59" fill="none" stroke="#fff" strokeWidth="2" />
      <circle cx="44.323" cy="50.309" r="1.295" fill="#6a6488" />
      <path
        d="M40.568 41.998h23.92c0-10.94-7.856-19.809-17.548-19.809-9.691 0-17.547 8.869-17.547 19.809h8.706l1.476-8.408"
        fill="#f78fa6"
      />
      <path
        d="M64.008 40.776c-.085.012-.098.022-.133.04a.393.393 0 0 0-.208.341v5.265c.014.4.746.553.767 0v-5.265c-.01-.275-.38-.385-.426-.381zM29.797 37.628a.4.4 0 0 0-.35.382v7.626c.009.189.057.215.113.271a.39.39 0 0 0 .654-.271V38.01a.397.397 0 0 0-.417-.382z"
        fill="#e57790"
        fillRule="nonzero"
      />
      <path
        d="M57.731 46.325a5.654 5.654 0 0 0-2.622.714c-.126.069-.47.339-.368.67.181.589 1.183-.03 2.034-.239 1.179-.289 2.444-.005 3.551.546 0 0 .251.095.443.006.382-.178.381-.747-.161-1.006-.901-.425-1.877-.698-2.877-.691zM44.162 46.325c-.992.016-2.02.224-2.811.826a.506.506 0 0 0-.072.067c-.326.365.064 1.093.793.696 1.433-.768 3.205-.635 4.685.102 0 0 .498.119.678-.216.47-.874-1.922-1.485-3.273-1.475z"
        fill="#f67f9a"
        fillRule="nonzero"
      />
      <path
        d="M65.569 49.671a.66.66 0 0 0-.612.62c-.013.915-.169 2.17.791 1.934.599-.147.498-1.125.487-1.934a.64.64 0 0 0-.666-.62zM28.402 49.671a.662.662 0 0 0-.612.62c-.012.915-.169 2.17.792 1.934.599-.147.498-1.125.486-1.934a.64.64 0 0 0-.666-.62z"
        fill="#afaacb"
        fillRule="nonzero"
      />
      <path
        d="M59.23 69.623a5.023 5.023 0 0 0-9.477 3.324l9.39 26.768a5.023 5.023 0 0 0 6.4 3.077 5.025 5.025 0 0 0 3.077-6.401l-9.39-26.768z"
        fill="#f8c45a"
      />
      <path
        d="M57.98 67.137a7.92 7.92 0 0 0-.734-3.467c-1.594-3.465-5.266-5.184-8.195-3.837-2.929 1.348-4.012 5.255-2.418 8.721a7.904 7.904 0 0 0 2.155 2.812l9.192-4.229z"
        fill="#fbe0e6"
      />
      <path
        d="M30.329 86.63a23.072 23.072 0 0 0 23.069 23.069v-9.039a14.028 14.028 0 0 1-14.03-14.03h-9.039z"
        fill="#f8c45a"
      />
      <path fill="#f8c45a" d="M52.74 100.626h26.255v9.073H52.74z" />
      <path
        d="M78.995 109.302c.917.42 1.957.64 3.016.64 3.33 0 6.033-2.141 6.033-4.779s-2.703-4.78-6.033-4.78a7.293 7.293 0 0 0-3.016.64v8.279z"
        fill="#fcecf0"
      />
      <path
        d="M175.291 8.874l-83.554 6.734v179.528l83.554-6.735V8.874z"
        fill="#756ca4"
      />
      <path
        d="M175.291 188.401l-83.554 6.735V15.608l83.554-6.734v179.527zM95.738 19.299V190.8l75.553-6.089V13.209l-75.553 6.09z"
        fill="#756ca4"
      />
      <path
        d="M128.258 47.355c0-2.753-2.221-4.81-4.956-4.589l-9.913.799c-2.735.22-4.956 2.634-4.956 5.388v36.65c0 2.753 2.221 4.809 4.956 4.589l9.913-.799c2.735-.221 4.956-2.635 4.956-5.388v-36.65zM158.583 44.911c0-2.754-2.221-4.81-4.956-4.59l-9.913.799c-2.735.221-4.956 2.635-4.956 5.389v36.649c0 2.754 2.221 4.81 4.956 4.589l9.913-.799c2.735-.22 4.956-2.634 4.956-5.388V44.911zM128.258 113.246c0-2.753-2.221-4.81-4.956-4.589l-9.913.799c-2.735.22-4.956 2.635-4.956 5.388v36.65c0 2.753 2.221 4.809 4.956 4.589l9.913-.799c2.735-.221 4.956-2.635 4.956-5.388v-36.65zM158.583 110.802c0-2.753-2.221-4.81-4.956-4.589l-9.913.799c-2.735.22-4.956 2.635-4.956 5.388v36.65c0 2.753 2.221 4.809 4.956 4.589l9.913-.799c2.735-.221 4.956-2.635 4.956-5.388v-36.65z"
        fill="#675e96"
      />
      <path
        d="M71.071 8.874l-49.015 7.087 4.508 216.86 65.173-37.685V14.684l83.554-5.81H71.071z"
        fill="url(#_Linear2)"
      />
      <path
        d="M181.812 3.211c0-.805-.653-1.458-1.459-1.458H70.485c-.806 0-1.459.653-1.459 1.458v4.204a1.46 1.46 0 0 0 1.459 1.459h109.868a1.46 1.46 0 0 0 1.459-1.459V3.211z"
        fill="#6a609b"
      />
      <path
        d="M177.968 188.848a.845.845 0 0 0 .844-.845V8.905a.844.844 0 0 0-.844-.844h-2.433a.844.844 0 0 0-.844.844v179.098c0 .466.378.845.844.845h2.433z"
        fill="#6a609b"
      />
      <path
        d="M99.654 104.834a2.83 2.83 0 0 0-2.829-2.829h-9.258a2.83 2.83 0 0 0-2.83 2.829 2.831 2.831 0 0 0 2.83 2.829h9.258a2.83 2.83 0 0 0 2.829-2.829z"
        fill="#404363"
      />
      <path
        d="M99.585 118.302a2.667 2.667 0 1 1 1.51 0l1.453 6.316h-4.416l1.453-6.316z"
        fill="#fcaf16"
      />
      <path
        d="M100.409 113.078l.068.003.068.004.067.006.067.008.067.009.066.011.065.013.065.014.064.016.064.017.063.019.062.02.061.022.061.023.061.024.059.026.059.028.058.029.057.03.056.031.055.033.055.034.054.035.052.037.052.038.051.039.05.04.049.041.048.043.046.043.046.045.045.046.044.047.042.048.041.048.041.05.039.051.037.052.037.053.035.053.034.055.033.055.032.057.03.057.029.058.027.058.026.06.025.06.023.061.021.061.021.063.018.063.018.063.015.064.014.065.013.065.011.066.009.067.008.067.006.067.004.068.003.068.001.069-.001.057-.002.056-.003.056-.004.056-.005.055-.006.055-.008.055-.008.054-.01.054-.011.054-.011.053-.013.052-.014.053-.015.052-.016.051-.017.051-.018.051-.018.05-.02.05-.021.049-.022.048-.023.049-.023.047-.025.047-.025.047-.027.046-.027.045-.028.045-.029.044-.03.043-.03.043-.032.042-.032.042-.033.041-.034.04-.035.04-.035.039-.036.038-.037.038-.038.036-.038.036-.039.036-.04.034-.04.034-.041.033-.042.032-.042.032-.043.03-.044.03-.044.029-.045.028-.045.027-.046.026-.047.025-.047.025-.047.023-.049.023-.048.022-.049.02-.05.02-.05.019-.051.018-.051.016-.052.016 1.453 6.316h-4.416l1.453-6.316-.052-.016-.051-.016-.051-.018-.05-.019-.05-.02-.049-.02-.049-.022-.048-.023-.047-.023-.047-.025-.047-.025-.046-.026-.045-.027-.045-.028-.044-.029-.044-.03-.043-.03-.042-.032-.042-.032-.041-.033-.04-.034-.04-.034-.039-.036-.039-.036-.037-.036-.037-.038-.036-.038-.035-.039-.035-.04-.034-.04-.033-.041-.032-.042-.032-.042-.03-.043-.03-.043-.029-.044-.028-.045-.027-.045-.027-.046-.025-.047-.025-.047-.023-.047-.023-.049-.022-.048-.021-.049-.02-.05-.018-.05-.018-.051-.017-.051-.016-.051-.015-.052-.014-.053-.013-.052-.012-.053-.01-.054-.01-.054-.008-.054-.008-.055-.006-.055-.005-.055-.004-.056-.003-.056-.002-.056-.001-.057.001-.069.003-.068.004-.068.006-.067.008-.067.009-.067.011-.066.013-.065.014-.065.015-.064.018-.063.018-.063.021-.063.021-.061.023-.061.025-.06.026-.06.027-.058.029-.058.03-.057.032-.057.033-.055.034-.055.035-.053.037-.053.037-.052.039-.051.041-.05.041-.048.042-.048.044-.047.045-.046.046-.045.046-.043.048-.043.049-.041.05-.04.051-.039.052-.038.052-.037.054-.035.055-.034.055-.033.056-.031.057-.03.058-.029.059-.028.059-.026.061-.024.06-.023.062-.022.062-.02.063-.019.064-.017.064-.016.065-.014.065-.013.066-.011.067-.009.066-.008.068-.006.068-.004.068-.003h.138z"
        fill="#56dbbe"
      />
    </g>
    <defs>
      <linearGradient
        id="_Linear2"
        x2="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(57.0151 0 0 107.087 34.722 86.533)"
      >
        <stop offset="0" stopColor="#59e9c9" stopOpacity="0" />
        <stop offset="1" stopColor="#59e9c9" stopOpacity="0.5" />
      </linearGradient>
    </defs>
  </svg>
);

export default PagedNotFoundIcon;
